import { useState } from "react";

import Typography from "../Typography/Typography";
import styles from "./TextInput.module.scss";

const TextInput = (props) => {
	const {
		type = "text",
		onChange = () => {},
		className,
		placeholder,
		label,
		setError = () => {},
		error = false,
		pattern = null,
		formatter = (value) => value,
		disabled = false,
		...rest
	} = props;

	const [formattedValue, setFormattedValue] = useState("");

	const handleChange = (value) => {
		let formatted = value;

		if (formatter) formatted = formatter(value);
		else if (pattern) formatted = value.replace(pattern, "");

		setFormattedValue(formatted);
		onChange(formatted);
	};

	return (
		<div className={`${styles.textInputContainer} ${className}`}>
			<Typography bold variant="h6">
				{label}
			</Typography>
			<input
				{...rest}
				className={`${styles.textInput} ${
					error && styles.textInputError
				}`}
				placeholder={placeholder}
				type={type}
				value={formattedValue}
				onFocus={(e) => {
					e.target.placeholder = "";
					setError(false);
				}}
				onBlur={(e) => (e.target.placeholder = placeholder)}
				onChange={(e) => handleChange(e.target.value)}
				disabled={disabled}
			/>
		</div>
	);
};

export default TextInput;
